export const styles = {
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		marginRight: '2rem',
		background: 'linear-gradient(180deg, #12BBF182 51%, #12BBF182 100%)',
	},
	responseContainer: {
		backgroundColor: 'rgba(231, 248, 255, 1)',
		padding: '1rem',
	},
	responseText: {
		fontSize: 16,
		color: 'black',
		opacity: 0.87,
	},
	listItem: {
		margin: '10px 0 10px 0',
	},
	mainContainer: {
		flexDirection: 'column',
		gap: '2rem',
		flexGrow: '1',
		paddingY: { xs: '0', sm: '1rem' },
	},
	headerContainer: {
		flexDirection: { xs: 'column', sm: 'row' },
		justifyContent: 'space-between',
		alignItems: { xs: 'flex-start', sm: 'center' },
		gap: '1rem',
	},
	radioButtonSectionContainer: {
		display: 'flex',
		alignItems: { xs: 'flex-start', sm: 'center' },
		justifyContent: { xs: 'flex-start', sm: 'space-between' },
		flexDirection: { xs: 'column', sm: 'row' },
		gap: '1rem',
	},
	radioButtonSelection: {
		color: '#C2C2C2', // Default color when not checked
		'&.Mui-checked': {
			color: '#45657b', // Color when the radio button is selected
		},
	},
	buttonContainer: {
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '1rem',
	},
	editButtonsContainer: {
		flexDirection: { xs: 'column', sm: 'row' },
		gap: '2rem',
	},
	editPromptContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'end',
	},
	textFieldContainer: {
		'.MuiInputBase-root': {
			height: '100%',
		},
	},
	cardContainer: {
		padding: '6px 8px 6px 0',
		alignItems: 'center',
		alignContent: 'center',
		gap: '8px',
		flexWrap: 'wrap',
	},
	numberedCard: {
		alignItems: 'center',
		gap: '12px',
		flexShrink: 0,
		'@media (min-width: 835px)': {
			width: '32%',
		},
	},
	cardHeader: (
		firstStepSelected: boolean,
		stageValue: string,
		isFirstSwapProcessSelected: boolean
	) => ({
		minHeight: '76px',
		maxheight: 'fit-content',
		padding: '8px',
		alignItems: 'center',
		flexShrink: 0,
		alignSelf: 'stretch',
		borderRadius: '4px',
		border: '1px solid var(--light-other-outlined-border-23-p, #0000003B)',
		background:
			firstStepSelected &&
			(stageValue === 'eliminate' ||
				(stageValue === 'swap' && isFirstSwapProcessSelected))
				? 'linear-gradient(90deg, rgba(14, 148, 166, 0.25) 0%, rgba(144, 218, 227, 0.25) 100%)'
				: 'none',
	}),
	stepNumber: {
		width: '32px',
		height: '32px',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '10rem',
		border: '1px solid var(--light-other-outlined-border-23-p, #0000003B)',
		background: 'var(--white-white, #FFF)',
	},
	stepNumberFont: (isSelected: boolean) => ({
		color: 'var(--Light-Text-Primary, #000000DE)',
		textAlign: 'center',
		fontFamily: 'sans-serif',
		fontSize: '12px',
		fontStyle: 'normal',
		fontWeight: '600',
		lineHeight: '28px',
		textDecorationLine: isSelected ? 'line-through' : 'none',
	}),
	numberedCardText: {
		padding: '0 8px',
		flexDirection: 'column',
		alignItems: 'flex-start',
		height: '100%',
		flexGrow: 1,
		alignContent: 'center',
		width: 'min-content',
	},
	numberedCardFont: (isSelected: boolean) => ({
		color: 'var(--Light-Text-Primary, #000000DE)',
		fontFamily: 'Roboto',
		fontSize: '12px',
		fontStyle: 'normal',
		fontWeight: '400',
		lineHeight: '17.16px',
		letterSpacing: '0.17px',
		textDecorationLine: isSelected ? 'line-through' : 'none',
	}),
	dividerContainerVisible: {
		visibility: 'visible',
	},
	dividerContainerHidden: {
		visibility: 'hidden',
	},
	boxDivider: {
		border: '1px dotted #0000003B',
		width: '19px',
	},
	fullHeight: {
		height: '100%',
	},
	contentContainer: {
		rowGap: '3rem',
	},
	ideasDropdown: {
		color: 'black',
	},
	editPromptText: {
		fontFamily: 'Roboto',
		fontSize: '12px',
		fontStyle: 'normal',
		fontWeight: 'normal',
		color: 'black',
		lineHeight: '14px',
		margin: '-10px -0 0 -10px',
	},
	editTextContainer: {
		marginTop: '-10px',
	},
	additionalStageNumLabel: {
		fontSize: '10px',
		fontFamily: 'Roboto',
	},
	radioGroupContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '0.5rem',
	},
	radioGroup: {
		display: 'flex',
		flexDirection: 'row',
		gap: '2rem',
		alignItems: 'center',
	},
	supportText: {
		color: '#757575',
		fontSize: '1.56rem', // 20% increase from 1.3rem
		textAlign: 'left',
		width: '100%',
		marginTop: '0.5rem',
		marginBottom: '0.5rem',
		'@media (max-width: 900px)': {
			fontSize: '1.25rem',
		},
		'@media (max-width: 600px)': {
			fontSize: '1.05rem',
		},
	},
}
